﻿var EmailValidate = {

    elements: {},
    messages: {},
    timeout: null,
    urls: {},

    config: function (elements, urls, messages, timeout) {
        EmailValidate.elements = elements;
        EmailValidate.urls = urls;
        EmailValidate.messages = messages;
        EmailValidate.timeout = timeout;

        $(function () {
            $("#" + EmailValidate.elements.containerId).inView(EmailValidate.init);
        });
    },

    init: function () {
        // Get and set rate limit for this user
        EmailValidate.rateLimit.setInitial();

        // Search field listener (keyup)
        $(document.body).on("keyup change paste input", "#" + EmailValidate.elements.searchFieldId, function (e) {
            EmailValidate.search.keyup(e);
        });

        // Search button listener
        $(document.body).on("click", "#" + EmailValidate.elements.searchBtnId, function () {
            EmailValidate.search.start();
        });

        // Retry button listener
        $(document.body).on("click", "#" + EmailValidate.elements.retryBtnId, function () {
            EmailValidate.toggleState();
            setTimeout(function () {
                $("#" + EmailValidate.elements.searchFieldId).focus();
            }, 0);
        });
    },

    rateLimit: {

        setInitial: function () {
            $.ajax({
                type: "POST",
                url: EmailValidate.urls.getRateLimit,
                success: function (response) {
                    EmailValidate.rateLimit.update(response.rateLimit, response.limitReason);
                },
                error: EmailValidate.search.handleError,
                dataType: "json",
                timeout: EmailValidate.timeout
            });
        },

        update: function (rateLimit, limitReason) {
            var limitMessage, limitReasonText;

            // Let internal users continue to search if IP blocking is the limitReason
            if (limitReason === "InternalIP") {
                rateLimit = 10;
                limitReasonText = "(Internal IP address)";
            } else if (limitReason === "StaffRole") {
                rateLimit = 10;
                limitReasonText = "(Staff access)";
            }

            if (rateLimit > 1) {
                limitMessage = EmailValidate.messages.searchCountMultiple.replace("{}", rateLimit);
                EmailValidate.search.enabled = true;
            }
            else if (rateLimit === 1) {
                limitMessage = EmailValidate.messages.searchCountSingle;
                EmailValidate.search.enabled = true;
            }
            else {
                limitMessage = EmailValidate.messages.searchCountNone;
                // Add messages to the limit string for particular reasons
                switch (limitReason) {
                    case "IPDailyLimit":
                        limitReasonText = EmailValidate.messages.ipDailyBlock;
                        break;
                    case "IPMonthlyLimit":
                        limitReasonText = EmailValidate.messages.ipMonthlyBlock;
                        break;
                    case "IPBlocked":
                        limitReasonText = EmailValidate.messages.ipPermanentBlock;
                        break;
                }
                // Disable searching and highlight warning if the rateLimit is less than 1
                EmailValidate.search.disable.permanent();
            }
            // Update the "searches remaining" text
            if (typeof limitReasonText !== "undefined") {
                limitMessage += "<br />" + Utilities.escapeHtml(limitReasonText);
            }
            $("." + EmailValidate.elements.rateLimitMessageClass).html(limitMessage);
            EmailValidate.search.enable();
            EmailValidate.toggleLoading();
        }
    },

    toggleState: function () {
        $("." + EmailValidate.elements.stateClass).toggleClass("hidden");
    },

    toggleLoading: function () {
        $("#" + EmailValidate.elements.containerId).toggleLoaders();
        $("." + EmailValidate.elements.stateClass + ".toggle-visibility").removeClass("invisible");
    },

    search: {

        enabled: true,

        input: {

            value: "",

            clear: function () {
                $("#" + EmailValidate.elements.searchFieldId).val("");
                EmailValidate.search.input.value = "";
                EmailValidate.search.enable();
                EmailValidate.search.disable.buttonOnly();
            }
        },

        keyup: function (e) {
            var $searchButton = $("#" + EmailValidate.elements.searchBtnId);
            EmailValidate.search.input.value = $("#" + EmailValidate.elements.searchFieldId).val();

            if (EmailValidate.search.enabled && EmailValidate.search.input.value !== "") {
                $("#" + EmailValidate.elements.submittedEmailId).text(EmailValidate.search.input.value);
                EmailValidate.search.enable();

                // "Submit" the "form" for the user if they press Enter
                if (e.keyCode === 13) {
                    $searchButton.click();
                }
            }
            else {
                EmailValidate.search.disable.buttonOnly();
            }
        },

        blur: function (e) {
            EmailValidate.search.input.value = $("#" + EmailValidate.elements.searchFieldId).val();

            if (EmailValidate.search.enabled && EmailValidate.search.input.value !== "") {
                $("#" + EmailValidate.elements.submittedEmailId).text(EmailValidate.search.input.value);
                EmailValidate.search.enable();

                // Initiate a search request
                EmailValidate.search.start();
            }
            else {
                EmailValidate.search.disable.buttonOnly();
            }
        },

        start: function () {
            if (EmailValidate.search.enabled) {

                EmailValidate.search.disable.once();
                EmailValidate.toggleLoading();

                $.ajax({
                    type: "POST",
                    url: EmailValidate.urls.validateEmail,
                    data: {
                        email: EmailValidate.search.input.value
                    },
                    success: function (result) {
                        if (result.result !== "") {
                            $("[data-status]").hide();
                            $("[data-status='" + result.result + "']").show();

                            var $corrections = $("." + EmailValidate.elements.suggestedCorrectionsClass);
                            $corrections.html("");
                            if (!Utilities.isNullOrEmpty(result.corrections)) {
                                var corrections = JSON.parse(result.corrections);
                                $.each(corrections, function (i) {
                                    if (!Utilities.isNullOrEmpty(corrections[i])) {
                                        $corrections.append($("<p/>").text(corrections[i]));
                                    }
                                });
                                $corrections.parent().show();
                            }
                            else {
                                $corrections.parent().hide();
                            }

                            EmailValidate.toggleState();
                            EmailValidate.search.input.clear();

                            // The button will re-activate when the input changes appropriately
                            EmailValidate.search.disable.once();
                        }
                        else {
                            // The rate limit was exceeded, so no result was returned
                            $("[data-status]").hide();
                        }
                        EmailValidate.rateLimit.update(result.rateLimit, result.limitReason);
                        $("#" + EmailValidate.elements.errorPanelId).hide();
                        EmailValidate.search.webAnalytics();
                    },
                    error: EmailValidate.search.handleError,
                    dataType: "json",
                    timeout: EmailValidate.timeout
                });
            }
        },

        webAnalytics: function (event) {
            // Push GTM dataLayer event for successful email validation
            Utilities.trackEvent({
                'event': 'EmailValidationDemo'
            });
        },

        enable: function () {
            if (EmailValidate.search.enabled) {
                $("#" + EmailValidate.elements.searchFieldId).removeAttr("disabled");
                if (EmailValidate.search.input.value !== "") {
                    $("#" + EmailValidate.elements.searchBtnId).removeAttr("disabled");
                }
            }
        },

        disable: {

            once: function () {
                $("#" + EmailValidate.elements.searchFieldId).attr("disabled", "disabled");
                $("#" + EmailValidate.elements.searchBtnId).attr("disabled", "disabled");
            },

            buttonOnly: function () {
                $("#" + EmailValidate.elements.searchBtnId).attr("disabled", "disabled");
            },

            permanent: function () {
                // Append a clone of the free trial button to the search container
                var $freeTrialBtn = $("#" + EmailValidate.elements.freeTrialBtnId);
                $freeTrialBtn.clone().insertAfter("#" + EmailValidate.elements.searchBtnId);

                // Hide search field and buttons
                $("#" + EmailValidate.elements.retryBtnId).parent().addClass("hidden");
                $("#" + EmailValidate.elements.searchBtnId).addClass("hidden");
                $("#" + EmailValidate.elements.searchFieldId).parent().addClass("hidden");
                $freeTrialBtn.parent().removeAttr("class").addClass("col-sm-12 col-md-10");

                // Turn the rate limit message into an alert
                $("." + EmailValidate.elements.rateLimitMessageClass).parent(".help-block")
                    .addClass("alert alert-danger")
                    .removeClass("help-block");

                // Disable searching
                EmailValidate.search.disable.once();
                EmailValidate.search.enabled = false;
            }
        },

        handleError: function (error) {
            // Populate the error message
            $("#" + EmailValidate.elements.errorMessageId).html(
                EmailValidate.messages.unknownError + " " +
                Utilities.escapeHtml(error.statusText) +
                " (" + Utilities.escapeHtml(error.status) + ")."
            );
            // Show the error block and hide other content
            EmailValidate.toggleLoading();
            $("." + EmailValidate.elements.stateClass).not(".headers").hide();
            $("#" + EmailValidate.elements.errorPanelId).removeClass("hidden");
            // Activate the retry button
            $(document.body).one("click", "#" + EmailValidate.elements.retryAfterErrorBtnId, function () {
                $("." + EmailValidate.elements.stateClass).not(".headers").show();
                $("#" + EmailValidate.elements.errorPanelId).addClass("hidden");
                EmailValidate.init();
                EmailValidate.toggleLoading();
            });
        }
    }

};